var map = {
	"./discord-st.png": 448,
	"./facebook.png": 1903,
	"./faceboook-st.png": 4681,
	"./instagram.png": 9956,
	"./linkedin-st.png": 6334,
	"./linkedin.png": 7783,
	"./some-random-one.png": 9015,
	"./sp-icon-fb.png": 5568,
	"./sp-icon-ig.png": 713,
	"./sp-icon-li.png": 1506,
	"./sp-icon-yt.png": 5743,
	"./twitter-st.png": 8020,
	"./whatsapp.png": 1453,
	"./youtube-st.png": 3464
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8027;